import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class ThemeResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/themes' as const;

  readonly id: number | undefined = undefined;
  
  pk() {
    return this.id?.toString();
  }

}
